<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex:1 }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '880px' }">
      <a-spin :spinning="!this.$store.state.countries10mData">
        <a-row>
            <a-row>
                <a-col :span="18" :xs="24" :sm="24" :md="24" :lg="18">
                    <h3 align="center">Population ages 65 and above (% of total population)</h3>
                </a-col>
                <a-col :span="6" :xs="24" :sm="24" :md="24" :lg="6">
                    <h3 align="center">World historic events</h3>
                </a-col>
            </a-row>
            <a-row >
               <a-col :span="18" :xs="24" :sm="24" :md="24" :lg="18">
                    <svg id="chart"  width="930" height="580"></svg>
                    <!-- style="background-color:lightblue" -->
                </a-col>
                <a-col :span="6" :xs="24" :sm="24" :md="24" :lg="6">
                    <div id="history" style="width:350px;height:580px;overflow:auto;background:#fff;white-space: pre-line;"></div>
                </a-col>
            </a-row>
            <a-row >
                <a-col :span="18" :xs="24" :sm="24" :md="24" :lg="18">
                  <svg id="slider-time" style="background-color: #fff"></svg>
                </a-col>
                <a-col :span="6" :xs="24" :sm="24" :md="24" :lg="6">
                </a-col>
            </a-row>
        </a-row>
    </a-spin>
    <!-- <div class="row align-items-center">
			<div class="col-sm" ><svg id="slider-time" style="background-color: #fff"></svg></div>
		</div> -->
		
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as d3slider from "d3-simple-slider"
import axios from "axios";
import * as topojson from "topojson";
import _ from "lodash";
export default {
  name: 'GlobalMap',
  methods: {
    makeWorldMap(){
      var world = this.countriesData;
      var initial_data = this.agingData;
      var history_data = this.historyData;
      var country_names = [];
      var years = [];
      var default_year = "2000";
      var color;
      var year_count = 1970;
      var all_data = [];
      initial_data.forEach(p => {
        // current_data.push(+p[years[years.length-1]]);
        if (year_count < 2020) {
            all_data.push(+p[year_count.toString()]);
            year_count = year_count + 1;
        }
        
      })
      color = d3.scaleQuantize([Math.min.apply(null,all_data), Math.max.apply(null,all_data)], d3.schemeReds[9])
      
      
      history_data.forEach(h => years.push(h.year));
      initial_data.forEach(p => country_names.push(p.Name));
      world.objects.countries.geometries.forEach(element => {
        if (country_names.includes(element.properties.name) == false){
            var new_obj = {}   
            new_obj.Name = element.properties.name;
            years.forEach(y => new_obj[y] = "0")
            initial_data.push(new_obj);
        }
      });
      history_data = Object.assign(new Map(history_data.map((d) => [d.year, d.event])));
      
      var dataTime = d3.range(0, 50).map(function(d) {
        return new Date(1970 + d, 10, 3);
      });
      
      var sliderTime = d3slider
        .sliderBottom()
        .min(d3.min(dataTime))
        .max(d3.max(dataTime))
        .step(1000 * 60 * 60 * 24 * 365)
        .width(1200)
        .tickFormat(d3.timeFormat('%Y'))
        .tickValues(dataTime)
        .default(new Date(2000, 10, 3))
        .on('onchange',_.throttle((val) =>{
            // console.log(val.getFullYear().toString());
            d3.select('p#value-time').text(d3.timeFormat('%Y')(val));
            this.redraw(world, initial_data, color, val.getFullYear().toString());
            this.history(history_data, val.getFullYear().toString());
        },100))
        
        
      var gTime = d3
        .select('#slider-time')
        // .append('svg')
        .attr('width', 1300)
        .attr('height', 100)
        .attr("background-color", "#fff !important")
        .append('g')
        .attr('transform', 'translate(30,30)');
      gTime.call(sliderTime);
      this.draw(world, initial_data, color, default_year);
      this.history(history_data, default_year);
    },
    draw(world, initial_data, color, cur_year){
      var format = d3.format(',.2f');
      var width = 1000;
      var height = 650;
      var svg = d3.select("#chart");
      svg.style("background-color","lightblue")
      svg.attr("viewBox", [0, 0, 1000, 650]);
      var data = initial_data;
      var projection = d3.geoMercator()
              .scale(width / 2 / Math.PI)
              .translate([width / 2, height / 2]);
      var path = d3.geoPath().projection(projection);
      data = Object.assign(new Map(data.map((d) => [d.Name, +d[cur_year]])));
      data.title = "Population ages 65 and above (% of total population)";
      svg.append("g")
        .attr("transform", "translate(610,500)")
        .append(() => this.legend({ color, title: data.title, width: 260 }));
        
      svg.append("g")
          .selectAll("path")
          .data(topojson.feature(world, world.objects.countries).features)  
          .join("path")
          .attr("fill",
              d => {
                  if (d.id == "462") {
                      return 'none';
                  }else {
                      if (data.get(d.properties.name) == 0) {
                          return 'white'
                      } else {
                          return color(data.get(d.properties.name));
                      }
                      
                  }
              }
          ) 
          .attr("d", path)
          .append("title")
          .text(d =>
          {
              if ((data.get(d.properties.name) == 0) || (data.get(d.properties.name) == null)) {
                  return `${d.properties.name}, no data`;
              }else {
                  //console.log(`${d.properties.name}, ${format(data.get(d.properties.name))}`)
                  if ((d.properties.name == "Japan") || (d.properties.name == "Italy")
                    || (d.properties.name == "France") || (d.properties.name == "Spain")
                    || (d.properties.name == "United Kingdom") || (d.properties.name == "Canada")
                    || (d.properties.name == "United States of America") || (d.properties.name == "Australia")
                    || (d.properties.name == "China") || (d.properties.name == "Turkey")
                    || (d.properties.name == "Mexico") || (d.properties.name == "Finland")
                    || (d.properties.name == "Iceland") || (d.properties.name == "Chile")) {
                        //console.log(`${d.properties.name}, ${color(data.get(d.properties.name))}`);
                  }
                  return `${d.properties.name}, ${format(data.get(d.properties.name))}`;
              }
              }
          ); 
          
      
      svg.append("path")
          .datum(topojson.mesh(world, world.objects.countries, (a, b) => a !== b))  
          .attr("fill", "none")
          .attr("stroke", "black")
          .attr("stroke-linejoin", "round")
          .attr("d", path);
    },
    redraw(world, initial_data, color, cur_year){
      var svg = d3.select("#chart");
      var data = initial_data;
      var current_data = [];
      var format = d3.format(',.2f');
      data.forEach(p => {
          current_data.push(+p[cur_year]);
      })
      data = Object.assign(new Map(data.map((d) => [d.Name, +d[cur_year]])));
        
      svg.selectAll("path")
          .data(topojson.feature(world, world.objects.countries).features)  
          .attr("fill",
              d => {
                  if (d.id == "462") {
                      return 'none';
                  }else {
                      if (data.get(d.properties.name) == 0) {
                          return 'white'
                      } else {
                          return color(data.get(d.properties.name));
                      }
                      
                  }
              }
          ) 
          .selectAll("title")
          .text(d =>
          {
              if ((data.get(d.properties.name) == 0) || (data.get(d.properties.name) == null)) {
                  return `${d.properties.name}, no data`;
              }else {
                  // console.log(`${d.properties.name}, ${format(data.get(d.properties.name))}`)
                  return `${d.properties.name}, ${format(data.get(d.properties.name))}`;
              }
              }
          ); 
    },
    history(history_data, cur_year) {
        // console.log(history_data);
        d3.select("#history")
            .text(history_data.get(cur_year));
    },
    
    
    legend({
        color,
        title,
        tickSize = 6,
        width = 320,
        height = 44 + tickSize,
        marginTop = 18,
        marginRight = 0,
        marginBottom = 16 + tickSize,
        marginLeft = 0,
        ticks = width / 64,
        tickFormat,
        tickValues
    } = {}) {  
        const svg = d3.create("svg")
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [0, 0, width, height])
            .style("overflow", "visible")
            .style("display", "block");
        let x;
        // Continuous
        if (color.interpolator) {
            x = Object.assign(color.copy()
                .interpolator(d3.interpolateRound(marginLeft, width - marginRight)),
                { range() { return [marginLeft, width - marginRight]; } });
            svg.append("image")
                .attr("x", marginLeft)
                .attr("y", marginTop)
                .attr("width", width - marginLeft - marginRight)
                .attr("height", height - marginTop - marginBottom)
                .attr("preserveAspectRatio", "none");
                //.attr("xlink:href", this.ramp(color.interpolator()).toDataURL());
            // scaleSequentialQuantile doesn’t implement ticks or tickFormat.
            if (!x.ticks) {
                if (tickValues === undefined) {
                    const n = Math.round(ticks + 1);
                    tickValues = d3.range(n).map(i => d3.quantile(color.domain(), i / (n - 1)));
                }
                if (typeof tickFormat !== "function") {
                    tickFormat = d3.format(tickFormat === undefined ? ",f" : tickFormat);
                }
            }
        }
        // Discrete
        else if (color.invertExtent) {
            const thresholds
                = color.thresholds ? color.thresholds() // scaleQuantize
                    : color.quantiles ? color.quantiles() // scaleQuantile
                        : color.domain(); // scaleThreshold
            const thresholdFormat
                = tickFormat === undefined ? d => d
                    : typeof tickFormat === "string" ? d3.format(tickFormat)
                        : tickFormat;
            x = d3.scaleLinear()
                .domain([-1, color.range().length - 1])
                .rangeRound([marginLeft, width - marginRight]);
            svg.append("g")
                .selectAll("rect")
                .data(color.range())
                .join("rect")
                .attr("x", (d, i) => x(i - 1))
                .attr("y", marginTop)
                .attr("width", (d, i) => x(i) - x(i - 1))
                .attr("height", height - marginTop - marginBottom)
                .attr("fill", d => d);
            tickValues = d3.range(thresholds.length);
            var f = d3.format(".2f");
            tickFormat = i => thresholdFormat(f(thresholds[i]), i);
        }
        svg.append("g")
            .attr("transform", `translate(0, ${height - marginBottom})`)
            .call(d3.axisBottom(x)
                .ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined)
                .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
                .tickSize(tickSize)
                .tickValues(tickValues))
            .call(g => g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height))
            .call(g => g.select(".domain").remove())
            .call(g => g.append("text")
                .attr("y", marginTop + marginBottom - height - 6)
                .attr("fill", "currentColor")
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text(title));
        return svg.node();
    },
    // ramp(color, n = 256) {
    //     const canvas = DOM.canvas(n, 1);
    //     const context = canvas.getContext("2d");
    //     for (let i = 0; i < n; ++i) {
    //         context.fillStyle = color(i / (n - 1));
    //         context.fillRect(i, 0, 1, 1);
    //     }
    //     return canvas;
    // }
  },
  
  mounted: function () {
    const API = this.$store.state.API;
    if (!this.$store.state.countries10mData && !this.$store.state.agingPopulationData && !this.$store.state.worldHistoryData) {
      const requestOne = axios.get(`${API}globalmap/countries-10m.json`);
      const requestTwo = axios.get(`${API}globalmap/aging_population.json`);
      const requestThree = axios.get(`${API}globalmap/world_history.json`);
      axios
        .all([requestOne, requestTwo, requestThree])
        .then(
          axios.spread((...responses) => {
            this.countriesData = responses[0].data;
            this.$store.commit("countries10mData", responses[0].data);
            this.agingData = responses[1].data;
            this.$store.commit("agingPopulationData", responses[1].data);
            this.historyData = responses[2].data;
            this.$store.commit("worldHistoryData", responses[2].data);
            this.makeWorldMap();
          })
        )
        .catch(errors => {
          console.error(errors);
        });
    } else {
      this.countriesData = this.$store.state.countries10mData;
      this.agingData = this.$store.state.agingPopulationData;
      this.historyData = this.$store.state.worldHistoryData;
      this.makeWorldMap();
    }
    
  },
}
</script>

<style scoped>
  
    .countries {
      fill: white;
    }
    .country-borders {
      fill: none;
      stroke: black;
      stroke-width: 0.5px;
      stroke-linejoin: round;
      stroke-linecap: round;
      pointer-events: none;
    }
    .legendThreshold {
      font-size: 12px;
      font-family: sans-serif;
  }
  .caption {
      fill: #000;
      text-anchor: start;
      font-weight: bold;
  }
</style>